import JWTDecode from "jwt-decode";

const JWTKEY = "[Danapay EndUser] JWTKey";

export const storeJWTToken = (token) => localStorage.setItem(JWTKEY, token);

export const getJWTToken = () => localStorage.getItem(JWTKEY);

export const removeJWTToken = async () => localStorage.removeItem(JWTKEY);

export const tokenIsValid = (token) => {
  if (!token) {
    return false;
  }
  const decoded = JWTDecode(token);
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    return false;
  }
  return true;
};

export const getIdFromToken = (token) => {
  if (!token) {
    return;
  }
  return Object(JWTDecode(token)).sub;
};
